import { Injectable } from '@angular/core';
import lables from '../../../assets/languages/languages.json'

@Injectable({
  providedIn: 'root'
})
export class LenguageService {
  lang: string = "default";

  constructor() {
    this.lang = navigator.language;

    if (this.lang) {
      this.lang = this.lang.slice(0, 2);
    }
  }

  getLang() {
    return (lables[this.lang]) ? this.lang : "default";
  }

  getLabel(label: string, params: any[] = []) {
    let text;
    if (lables[this.lang]) {
      text = lables[this.lang][label] || label
    } else {
      text = lables["default"][label] || label
    }

    params.map((p, i) => {
      text = text.replace("%" + i + "%", p)
    })

    return text;
  }


}
